import React, { ReactNode, useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { CloseIcon } from "../svgIcons";
import '../styles/Popup.scss';
import { popupFade } from "../styles/MotionFramerAnimations";
type PopupProps = {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    showCloseButton?: boolean;
}

export const Popup: React.FC<PopupProps> = ({
    isOpen,
    onClose,
    children,
    showCloseButton = true,
}) => {
    const popupRef = useRef<HTMLDivElement>(null);
    const [xOffset, setXOffset] = useState<string>("-50%");

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            if (popupRef.current && !popupRef.current.contains(target) && !target.closest(".club-button")) {
                onClose();
            }
        };

        if (isOpen && popupRef.current) {
            const popup = popupRef.current;
            const rect = popup.getBoundingClientRect();

            let offset = "-50%";

            if (rect.right > window.innerWidth) {
                const overflowRight = rect.right - window.innerWidth + 16;
                offset = `calc(-50% - ${overflowRight}px)`;
            }

            else if (rect.left < 0) {
                const overflowLeft = Math.abs(rect.left) + 16;
                offset = `calc(-50% + ${overflowLeft}px)`;
            }
            setXOffset(offset)
        }
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <motion.div
            className="club-popup"
            ref={popupRef}
            {...popupFade(xOffset)}
        >
            <div
                className="popup-content"
            >
                {showCloseButton && (
                    <button className="popup-close" onClick={onClose} aria-label="Close">
                        {CloseIcon()}
                    </button>
                )}
                <div className="popup-body">{children}</div>
            </div>
        </motion.div>
    );
};